// extracted by mini-css-extract-plugin
export default {"newproject_container":"NewProject_newproject_container__X+dfs"};